import React from 'react';
import { useCopyToClipboard } from 'react-use';
import { useAppState } from '../App/AppContext';
import { storage } from '../firebase';
import { formatBytes, isAdmin } from '../utils';
import { Card, Grid, Image, Segment } from 'semantic-ui-react';

var listRef = storage.ref('/images/');

export const ImageLoader = () => {
  const [file, setFile] = React.useState<any>(null);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [url, setURL] = React.useState('');

  const { user } = useAppState();
  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    if (e.target && e.target.files) {
      setFile(e.target.files[0]);
    }
  }

  function handleUpload(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const uploadTask = storage.ref(`/images/${file.name}`).put(file);
    uploadTask.on('state_changed', console.log, console.error, () => {
      storage
        .ref('images')
        .child(file.name)
        .getDownloadURL()
        .then((url) => {
          setFile(null);
          setURL(url);
        });
    });
  }

  const Picture = ({
    storageReference,
    onDelete,
  }: {
    storageReference: firebase.storage.Reference;
    onDelete: () => void;
  }) => {
    const [, copyToClipboard] = useCopyToClipboard();
    const [deleting, setDeleting] = React.useState<boolean>();
    const [meta, setMeta] = React.useState<any>();

    React.useEffect(() => {
      storageReference.getMetadata().then((m) => {
        console.log(m);
        setMeta(m);
      });
    }, [storageReference]);

    const handleDelete = async () => {
      setDeleting(true);
      await storageReference.delete();
      setDeleting(false);
      onDelete();
    };
    const [url, setUrl] = React.useState<string>();
    React.useEffect(() => {
      storageReference.getDownloadURL().then((value) => {
        setUrl(value);
      });
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
      <Card>
        <Image src={url} alt="" wrapped ui={false} />
        <Card.Content>
          <button onClick={() => copyToClipboard(url || '')}>Copy URL</button>
          <div>{storageReference.name}</div>
          <div>{`size: ${formatBytes(meta?.size || 0)}`}</div>
          <button onClick={handleDelete}>
            {deleting ? 'Deleting...' : 'Delete'}
          </button>
        </Card.Content>
      </Card>
    );
  };

  const Images = () => {
    const [images, setImages] = React.useState<firebase.storage.Reference[]>(
      []
    );

    React.useEffect(() => {
      listRef
        .listAll()
        .then(function (res) {
          setImages(res.items);
        })
        .catch(function (error) {
          console.error(error);
        });
    }, []);
    // Find all the prefixes and items.

    return (
      <Grid>
        {images.map((x) => (
          <Picture
            storageReference={x}
            key={x.name}
            onDelete={() => {
              setImages((s) => s.filter((i) => i.name !== x.name));
            }}
          />
        ))}
      </Grid>
    );
  };

  return (
    <div>
      {isAdmin(user) ? (
        <Segment padded>
          <form onSubmit={handleUpload}>
            <input type="file" onChange={handleChange} />
            <button disabled={!file}>upload to firebase</button>
          </form>
        </Segment>
      ) : null}
      <Images />
    </div>
  );
};
